import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

export default {
    namespaced: true,

    store: {
        roles: [],
        posts: []
    },

    mutations: {
        setRoles(state, roles) {
            state.roles = roles.map(i => ({
                value: i.name,
                label: i.description
            }));
        },
        setPosts(state, posts) {
            state.posts = posts.map(i => ({ value: i.id, label: i.name }));
        }
    },

    actions: {
        // список таблиц с настройками
        async getList(ctx, params) {
            const token = ctx.rootState.authToken;
            const searchParams = {
                auth_key: ctx.rootState.authToken,
                r: "api/columns-settings/index",
                page: params.page
            };

            if (params.query) {
                searchParams.search = params.query;
            }

            if (params.sortBy) {
                searchParams.sort = `${params.sortType === "desc" ? "-" : ""}${
                    params.sortBy
                }`;
            }

            const search = Object.entries(searchParams)
                .map(([key, value]) => `${key}=${value}`)
                .join("&");

            const res = await fetch(addAuthKey(`${api_url}/?${search}`, token));

            const json = await res.json();

            return json;
        },

        // удалить настройки для таблицы
        async removeTableSettings(ctx, params) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/columns-settings/delete&id=${params.id}`, token),
                {
                    method: "DELETE"
                }
            );

            const json = await res.json();

            return json;
        },

        // получить список всех таблиц
        async getTables(ctx) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/columns-settings/table-sections`, token)
            );

            const json = await res.json();

            return json;
        },

        // получить сохраненные настройки таблицы
        async getTableSettings(ctx, params) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/columns-settings/view&id=${params.id}`, token)
            );

            const json = await res.json();

            return json;
        },

        // получить набор столбцов для таблицы
        async getTableColumns(ctx, params) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/columns-dictionary/list&section=${params.table}`, token)
            );

            const json = await res.json();

            return json;
        },

        // список ролей
        async getRoles(ctx) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/roles/list`, token)
            );

            const json = await res.json();

            ctx.commit("setRoles", json);

            return json;
        },

        // список должностей
        async getPosts(ctx) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/posts-list`, token)
            );

            const json = await res.json();

            ctx.commit("setPosts", json.response);
        },

        // создать настройки для новой таблицы
        async createTableSettings(ctx, params) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/columns-settings/create`, token),
                {
                    method: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(params)
                }
            );

            const json = await res.json();

            return json;
        },

        // обновить настройки для новой таблицы
        async updateTableSettings(ctx, params) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/columns-settings/update&id=${params.id}`, token),
                {
                    method: "PUT",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(params)
                }
            );

            const json = await res.json();

            return json;
        }
    }
};
